
export function roundMoney(n: number): number {
  return Math.round((Number(n) + Number.EPSILON) * 100) / 100;
}

export function employmentGross(basicSalary: number, allowanceTotal: number): number {
  return Math.max(0, roundMoney(Number(basicSalary) + Number(allowanceTotal)));
}

export function netPaySalary(
  basicSalary: number,
  allowanceTotal: number,
  additionalPay: number,
  deduction: number,
  eventDeduction: number = 0,
): number {
  const gross = employmentGross(basicSalary, allowanceTotal);
  const net = gross + Number(additionalPay) - Number(deduction) - Number(eventDeduction);
  return Math.max(0, roundMoney(net));
}
